import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return toast.error('Masukkan email Anda');
        try {
            setLoading(true);
            await axios.post(`${API_BASE}/api/auth/forgot-password`, { email: email.trim() });
            setSubmitted(true);
        } catch (err) {
            toast.error(err.response?.data?.detail || 'Gagal memproses permintaan');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-brand-background p-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow-lg border border-brand-border p-8" data-testid="forgot-password-page">
                <Link to="/login" className="inline-flex items-center text-sm text-brand-text-muted hover:text-brand-primary mb-4" data-testid="back-to-login">
                    <ArrowLeft className="w-4 h-4 mr-1" /> Kembali ke login
                </Link>

                {!submitted ? (
                    <>
                        <h1 className="text-2xl font-bold text-brand-text-primary mb-2">Lupa Password</h1>
                        <p className="text-sm text-brand-text-secondary mb-6">
                            Masukkan email akun Anda. Kami akan mengirim link reset password yang berlaku selama 15 menit.
                        </p>
                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div className="space-y-2">
                                <Label htmlFor="email" className="text-brand-text-primary font-medium">Email</Label>
                                <Input
                                    id="email"
                                    type="email"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="bg-brand-background border-brand-border"
                                    data-testid="forgot-email-input"
                                />
                            </div>
                            <Button type="submit" disabled={loading} className="w-full bg-brand-primary hover:bg-brand-primary-dark text-white h-11" data-testid="forgot-submit-btn">
                                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
                                Kirim Link Reset
                            </Button>
                        </form>
                    </>
                ) : (
                    <div className="text-center py-4" data-testid="forgot-success">
                        <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" />
                        <h2 className="text-xl font-bold text-brand-text-primary mb-2">Periksa Email Anda</h2>
                        <p className="text-sm text-brand-text-secondary mb-6">
                            Jika email <strong>{email}</strong> terdaftar, kami telah mengirim link reset password. Link ini berlaku selama <strong>15 menit</strong>.
                        </p>
                        <p className="text-xs text-brand-text-muted mb-6">Tidak menerima email? Periksa folder spam atau coba lagi dalam beberapa menit.</p>
                        <Button onClick={() => { setSubmitted(false); setEmail(''); }} variant="outline" className="w-full" data-testid="forgot-resend-btn">
                            Kirim ke email lain
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
